module.exports = __webpack_public_path__ + "media/newstyle/images/icon-cross-white-5f7ac8580438ade4bafbaea093cfd758.svg";